"use client"
import { useEffect, useState } from 'react';
import { IData, IBus } from "@/types";
import { useCookies } from 'react-cookie';
import StartBtn from "./StartBtn";
export default function Xingmo({ data, lang, bus }: { data: IData, lang: string, bus: IBus }) {

  const [userInfoCookie] = useCookies(['userInfo']);

  const [role, setRole] = useState<string>('');
  useEffect(() => {
    setRole(userInfoCookie?.userInfo?.role || '');
  }, [userInfoCookie?.userInfo?.role]);

  return (
    <div className="w-[100vw] h-[100vh] bg-[url('/images/xingmo/bg.jpg')] bg-cover bg-center flex items-center justify-center flex-col text-center">
      {/* <img src={data.homeLogoUrl} className="object-contain h-[80px] mt-7" /> */}
      <img src="/images/xingmo/logo.webp" className="object-contain h-[40px] mt-7" />
      <img src="/images/xingmo/slogan.webp" style={{ height: '160px' }}></img>
      <div className="mb-[36px] flex bg-[#E3ECFF] rounded-full px-5 py-2.5 text-base font-bold text-[#1765FF]">
        智能引导写作，激发创意思维，助力学生个性化成长
      </div>


      <div className="text-[#303133] text-base/7 mb-10">
        与其他大模型、智能体评改作文相比，<br />
        行墨智能体更看重学生写作思维指导文本生成原理点拨，更强调学生认知过程的优化。
      </div>

      <div className="flex justify-center items-center gap-x-5">
        {
          !role || role == '2' ? (
            <StartBtn bus={bus} isExpired={data.expiredFlag} className="cursor-pointer">
              <div className="w-[150px] h-[48px] rounded-full bg-[#1765FF] shadow-[0_2px_6px_0_rgba(0,0,0,0.1)] flex items-center justify-center cursor-pointer hover:bg-[#1765FF]/80 transition-all duration-300">
                <span className="font_family icon-Slider text-2xl! text-white"></span>
                <div className="text-white text-sm/6 font-bold">教师端</div>
              </div>
            </StartBtn>
          ) : null
        }
        {/* <StartBtn bus={bus} isExpired={data.expiredFlag} className="cursor-pointer" >
          <div className="w-[150px] h-[48px] rounded-full bg-[#1765FF] shadow-[0_2px_6px_0_rgba(0,0,0,0.1)] flex items-center justify-center cursor-pointer hover:bg-[#1765FF]/80 transition-all duration-300">
            <span className="font_family icon-Slider text-2xl! text-white"></span>
            <div className="text-white text-sm/6 font-bold">教师端</div>
          </div>
        </StartBtn> */}

        {
          !role || role == '1' ? (
            <StartBtn bus={bus} isExpired={data.expiredFlag} className="cursor-pointer">
              <div className="w-[150px] h-[48px] rounded-full bg-white shadow-[0_2px_6px_0_rgba(0,0,0,0.1)] flex items-center justify-center cursor-pointer hover:bg-white/80 transition-all duration-300">
                <span className="font_family icon-Zuowenpigai text-2xl! text-[#1765FF]"></span>
                <div className="text-[#1765FF] text-sm/6 font-bold">学生端</div>
              </div>
            </StartBtn>
          ) : null
        }



      </div>
    </div>
  );
}
